import { GridApi } from '@ag-grid-community/core';
import { useCallback, useRef, useState } from 'react';

export const useAgGrid = (gridLoadedFn?): [{ api: GridApi } | undefined, any] => {
    const gridApi = useRef<{ api: GridApi } | null>(null);
    const [ api, setApi ] = useState<{ api: GridApi }>();

    const onGridReady = useCallback((params) => {
        if (!params.api.isDestroyed()) {
            if (!gridApi.current) {
                gridApi.current = { api: params.api };
            }

            if (gridLoadedFn) {
                gridLoadedFn(params);
            }
            setApi(gridApi.current);
        }
    }, [gridLoadedFn]);

    return [ api, onGridReady ];
};